// src/seo/hreflang.js

import { SUPPORTED_LOCALES } from "../utils/locales";
import { SITE_URL, getPageLocales } from "./publicPages";

export function installHreflang({ router, defaultLocale = "en" }) {
  const supportedLocales = SUPPORTED_LOCALES;

  function parseLocaleAndBasePath(path) {
    // path like "/de/legal" or "/en" or "/"
    const segments = (path || "/").split("/").filter(Boolean);

    const maybeLocale = segments[0];
    const hasLocalePrefix = supportedLocales.includes(maybeLocale);

    const locale = hasLocalePrefix ? maybeLocale : defaultLocale;
    const baseSegments = hasLocalePrefix ? segments.slice(1) : segments;

    const basePath = baseSegments.length ? `/${baseSegments.join("/")}` : "/";
    return { locale, basePath };
  }

  function buildUrl(origin, locale, basePath) {
    // basePath "/" -> no trailing slash after locale
    const suffix = basePath === "/" ? "" : basePath;
    return `${origin}/${locale}${suffix}`;
  }

  function removePrevious() {
    document.head.querySelectorAll("link[data-i18n-seo='1']").forEach(n => n.remove());
  }

  function applyLinks(route) {
    const { locale, basePath } = parseLocaleAndBasePath(route.path);

    // <html lang="..">
    document.documentElement.setAttribute("lang", locale);

    removePrevious();

    // Private lists and missing pages are not alternate public landing pages.
    if (!route.params.lang || route.name === "localized-not-found" || route.name === "not-found")
      return;
    const pageLocales = getPageLocales(basePath === "/" ? "" : basePath, supportedLocales);
    if (!pageLocales.length) return;

    // canonical
    const canonicalHref = buildUrl(SITE_URL, locale, basePath);
    const canonical = document.createElement("link");
    canonical.rel = "canonical";
    canonical.href = canonicalHref;
    canonical.setAttribute("data-i18n-seo", "1");
    document.head.appendChild(canonical);

    // alternates (include self)
    pageLocales.forEach(l => {
      const link = document.createElement("link");
      link.rel = "alternate";
      link.hreflang = l;
      link.href = buildUrl(SITE_URL, l, basePath);
      link.setAttribute("data-i18n-seo", "1");
      document.head.appendChild(link);
    });

    // x-default (default locale version of same page)
    const xdef = document.createElement("link");
    xdef.rel = "alternate";
    xdef.hreflang = "x-default";
    xdef.href = buildUrl(SITE_URL, defaultLocale, basePath);
    xdef.setAttribute("data-i18n-seo", "1");
    document.head.appendChild(xdef);
  }

  // Runs on initial resolution and every successful SPA navigation. Using the
  // resolved route avoids stale window.location values and deferred-update races.
  router.afterEach(applyLinks);
}
